module.exports = __webpack_public_path__ + "img/left_4_hover.4a5a0b7f.png";